import React from 'react';
import {Link, Route} from 'react-router-dom';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import routes from '../../routes';
import Utils from "../../common/Utils";
import {css} from 'glamor';
import UrlPattern from 'url-pattern';

const patternRoutes = Object.keys(routes).map(x => ({
  pattern: new UrlPattern(x),
  key: x
}));

const breadcrumbStyle = css({
  marginBottom: 0
});

const findRouteName = url => {
   let frame = patternRoutes.find(x => x.pattern.match(url));
   return frame ? routes[frame.key] : null;
};

const getPaths = (pathname) => {
  const paths = ['/'];

  if (pathname === '/') return paths;

  pathname.split('/').reduce((prev, curr, index) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

const BreadcrumbsItem = ({  match , ...rest}) => {
  const routeName = findRouteName(match.url);
  if (routeName) {
    return (
      match.isExact ?
      (
        <BreadcrumbItem active>{routeName}</BreadcrumbItem>
      ) :
      (
        <BreadcrumbItem>
          <Link to={match.url || ''}>
            {routeName}
          </Link>
        </BreadcrumbItem>
      )
    );
  }

  //  we want a disabled link
  return <BreadcrumbItem active>{Utils.ucFirst(match.url.substring(1))}</BreadcrumbItem>
};

const Breadcrumbs = ({ ...rest, location, match }) => {

  const { pathname } = location;
  const _routeInfo = findRouteName(pathname);
  if(Array.isArray(_routeInfo)){
    return <Breadcrumb listClassName={`${breadcrumbStyle}`}>
      {_routeInfo.map((item,index) => <BreadcrumbItem key={index} active={index === _routeInfo.length - 1}>{item}</BreadcrumbItem>)}
    </Breadcrumb>;
  }

  const paths =  getPaths(pathname);
  const i = 0;
  const items = paths.map((path, i) => <Route key={i++} path={path} component={BreadcrumbsItem} />);
  return (
        <Breadcrumb listClassName={`${breadcrumbStyle}`}>
          {items}
        </Breadcrumb>
  );
};

export default props => (
  <div>
    <Route path="/:path" component={Breadcrumbs} {...props} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js